// extracted by mini-css-extract-plugin
module.exports = {"limitedText":"ReadFullNote_limitedText__WpYan","overflowing":"ReadFullNote_overflowing__15G27"};